export default __webpack_public_path__ + "static/media/rm-you-won.24a4e872.svg";